module.exports = __webpack_public_path__ + "img/grooming.e13deebdefd1d9dc5754167fedb44acc.jpg";